import React from 'react';

export default function PropertyPageHeader({ title, description, children }) {
  return (
    <div className="flex justify-between items-center mt-2 pb-6 mb-8 border-b border-neutral-300 w-full">
      <div className="flex flex-col gap-[6px] ">
        <h1 className="text-4xl font-medium font-serif text-neutral-900">
          {title}
        </h1>
        <p className="text-md font-normal text-neutral-500">{description}</p>
      </div>
      {children}
    </div>
  );
}
